import { combineReducers } from 'redux';
import webSiteUser from './normaluser';
export default combineReducers({
    webSiteUser,

})